import "./contentpage.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // <-- import useNavigate
import AvatarPicker from "../components/AvatarPicker";
import ProfileAvatar from "../components/ProfileAvatar";

function Avatar() {
  const [selectedAvatar, setSelectedAvatar] = useState(() => {
    try {
      return localStorage.getItem("avatar") || "";
    } catch {
      return "";
    }
  });

  const navigate = useNavigate(); // hook to navigate programmatically

  const handleSubmit = () => {
    // You can also do any final saving or validation here if needed
    navigate("/"); // navigate back to the home page
  };

  return (
    <div
  style={{
    padding: "20px",
    fontSize: "1.125em",
    lineHeight: "1.6",
    fontFamily: "Georgia, serif",
  }}
>
      <h1>Welcome to Your Learning Dashboard</h1>
      <ProfileAvatar />
      <AvatarPicker onSelect={setSelectedAvatar} />

      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <button
          onClick={handleSubmit}
          style={{
            color: "white",
            padding: "10px 20px",
            fontSize: "16px",
            fontWeight: "bold",
            backgroundColor: "#034d28", // gold color
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default Avatar;
